export default "__VITE_ASSET__edwiN0rF__"